var cookieBar = document.getElementById("cookie-bar");
var getCookie = function (name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
};

var hasAcceptedCookies = getCookie('has-accepted-cookies');

if (!hasAcceptedCookies) {
  cookieBar.classList.remove('_hidden');
}

document.getElementById('cookie-button').addEventListener('click', function () {
  cookieBar.classList.add("display-none");
  document.cookie = 'has-accepted-cookies=true';
  cookieBar.classList.add('_hidden');
});



// WEBPACK FOOTER //
// ./resources/assets/js/cookie-bar.js